export default __webpack_public_path__ + "static/media/geomine-count.f9f250d9.svg";